import AdsEngagePage from "./AdsEngagePage";
import { KYDScope } from "@common/interfaces/ICognito";

const AdsCampaigns = ({ permissions = [] }: { permissions?: KYDScope[] }) => (
  <AdsEngagePage permissions={permissions} />
);

export default AdsCampaigns;
